
import '../../App.css'

const About = () => {

     return (
          <div id='#about' className=' px-3  content  md:px-10 lg:px-20 overflow-hidden max-w-[1500px] mx-auto '>
               <div>
                    <div className='text-center '>
                         <div>
                              <h1
                                   data-aos="fade-zoom-in"
                                   data-aos-easing="ease-in-back"
                                   data-aos-delay="300"
                                   data-aos-offset="0"
                                   className='text-[80px] md:text-[130px] font-extrabold   text-gray-500  text-opacity-20'>ABOUT ME</h1>
                         </div>
                         <h3 className='text-[35px] md:text-[40px] relative font-semibold    text-white -mt-[88px] md:-mt-32'>Know Me More</h3>
                         <div class="flex -mt-2  overflow-hidden  justify-center">
                              <div class="w-16 h-1 rounded-full bg-indigo-500 inline-flex"></div>
                         </div>
                    </div>

                    <div
                         className='py-24'
                         data-aos="fade-up"
                         data-aos-duration="1000"
                    >
                         <div className='lg:flex w-full   justify-center   gap-16 text-gray-400 '>
                              <div className='w-full   lg:w-8/12 2xl:w-12/12'>
                                   <h2 className='text-4xl text-gray-300 font-semibold'>I'm Saroar, a Web Developer</h2>
                                   <p className=' font-normal mt-3 text-justify leading-7 text-[17px] text-gray-400'>
                                        Assalamu Alaikum🌟! I'm Saroar Jahan, a dedicated MERN-Stack & Frontend Developer. With  2-years journey in web development, im always up-to-date with the latest trends and technologies. I have a passion for making things work - no matter the size or scope of the project. My skills include HTML5, CSS3, Tailwind, and  JavaScript  Bootstrap. I am  comfortable working with React Js, Firebase, MongoDB and Express JS. <br /> <br />

                                        Also i have successfully designed and developed responsive, user-friendly websites and web applications. These projects showcase my ability to bring creativity and functionality together seamlessly.</p>
                              </div>
                              <div

                                   data-aos="fade-up"
                                   data-aos-duration="1000"

                              >
                                   <div className='flex flex-col mt-10 gap-y-7 md:gap-y-9'>
                                        <p className='border-b border-gray-700 pb-2'><b>Full Name:</b> MD.Saroar Jahan (Bappy)</p>
                                        <p className='border-b border-gray-700 pb-2'><b>Email:</b> muhammadbappy989@gmail.com</p>
                                        <p className='border-b border-gray-700 pb-2'><b>Age:</b> 21 Years old</p>
                                        <p className='border-b border-gray-700 pb-2'><b>From:</b> Rajshahi, Bangladesh</p>

                                   </div>
                              </div>
                         </div>

                    </div>
               </div>
          </div>
     );
};

export default About;